export default function createBidMessagingSubject(bidId, type) {
  return `${bidId}-${type}`;
}
